import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { InformacionGeneralForm } from "./informacion-general-form";

export function InformacionGeneralRoutes() {
  return (
    <RoleGuard roles={["empresa:informacion-general"]}>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route index element={<Navigate to="edit" replace />} />

          <Route path="edit" element={<InformacionGeneralForm />} />

          <Route path="*" element="InformacionGeneralRoutes: Page Not Found" />
        </Route>
      </Routes>
    </RoleGuard>
  );
}
